@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title | uppercase}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class='alert alert-warning' role='alert'>{{error}}</div>
              </div>
            }
          </div>
        }
      </div>
      <!-- NUMBER & TYPE & VEHICLE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-4">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    <strong>{{'tableManagement.cardLists.number' | translate}} (*)</strong>
                </label>
          <input type="text" id="card-number" class="form-control custom-input" [(ngModel)]="entity.number" [disabled]="!isNew || saving"
            [style]="{'width':'100%'}">
        </div>
        <div class="col-sm-4">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
						  <strong>{{'control-panel.vehicles.vehicleType' | translate}} (*)</strong>
                </label>
          <p-select [options]='typesList' [(ngModel)]='entity.type'
            placeholder="{{'control-panel.vehicles.vehicleType' | translate}}" dataKey='id'
            (onChange)="onChangeType($event)"
            (onFilter)="onFilterType($event)"
            [style]="{'width':'100%'}" appendTo='body' [filter]="true" filterBy="formatTypeLabel" [disabled]="saving" optionLabel="formatTypeLabel">
            <ng-template let-type pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ type.name }} - {{ type.codeProductLimit }} - {{ type.operationLimit }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>
        <div class="col-sm-4">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
						  <strong>{{'tableManagement.cardLists.vehicle' | translate}} (*)</strong>
                </label>
          <p-select [options]='vehicleList' [(ngModel)]='entity.vehicle' [placeholder]="vehiclePlaceholder"
            dataKey='id' optionLabel='name' [style]="{'width':'100%'}" appendTo='body' [filter]="true"
            filterBy="name" (onChange)="onChangeVehicle($event)" (onFilter)="onFilterVehicle($event)"
            [readonly]="vehicle" [disabled]="saving">
          </p-select>
        </div>
      </div>
      <!-- EXPIRATION DATE & DEASSIGN DATE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-4">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
						  <strong>{{'tableManagement.cardLists.expirationDateShort' | translate}} (*)</strong>
                </label>
          <p-datepicker [(ngModel)]='expirationDate' [showTime]='false' [style]="{'width':'100%'}"
          dateFormat='{{i18n.dateFormat}}' showIcon='true' appendTo='body' [firstDayOfWeek]="1" [disabled]="saving"></p-datepicker>
        </div>
        <div class="col-sm-4">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.cardLists.deassignDateShort' | translate}}
                </label>
          <p-datepicker [(ngModel)]='deassignDate' [showTime]='true'
            [style]="{'width':'100%'}" dateFormat='{{i18n.dateFormat}}' showIcon='true'
          appendTo='body'  [firstDayOfWeek]="1" [disabled]="saving"></p-datepicker>
        </div>
        <div class="col-sm-4">
        </div>
      </div>
      <!-- OBSERVATIONS -->
      <div class="row justify-content-start mt-3">
        <div class="col-12">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'general.observations' | translate}}
                </label>
          <textarea rows="2" cols="80" pInputTextarea [pTooltip]="entity.observations" tooltipPosition="top"
          [(ngModel)]="entity.observations" class="observations w-100" fitContent="true" [disabled]="saving"></textarea>
        </div>
      </div>
      <!-- ACTIVE -->
      <div class="row justify-content-start mt-3">
        <div class="col-12">
          <label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
            type="checkbox" [(ngModel)]="active" [disabled]="true">
        </div>
      </div>
      @if (!isNew) {
        <div class="mt-3">
          <app-cardConsumption-list [card]="entity">
          </app-cardConsumption-list>
        </div>
      }
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew && canCreate) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="saving">
                        {{ saving ? ('general.saving' | translate) : ('general.create' | translate) }}
                    </button>
            </div>
          }
          @if (!isNew && canUpdate) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="saving">
                        {{ saving ? ('general.saving' | translate) : ('general.save' | translate) }}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew && canChangeStatus) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(active)" i18n [disabled]="saving">
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
